import { useForm } from "react-hook-form";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import axios from "../../../axios";
import * as styled from "./AddManager.styled"
import { useState } from "react";
import { CommonBtn } from "../../../styles/components/Button.styled";
import TextInput from "../../../components/TextInput/TextInput";

export const fields = [
  {name: 'name', inputName: "Ім’я"},
  {name: "managerId", inputName: "Id менеджера"},
  {name: 'phoneNumber', inputName: "Номер телефону"},
  {name: 'email', inputName: "Email"},
  {name: 'password', inputName: "Пароль"},
]


function AddManager({adminInfo}){
    const [successAdded, setSuccessAdded] = useState(null);
    
   const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
      setValue
   } = useForm({
      defaultValues: {
      name: "",
      managerId: "",
      phoneNumber: "",
      email: "",
      password: "",
      accessType: adminInfo.accessType || 'en',
      userType: "manager",
      },
      mode: "onChange",
   });
   const onSubmit = async (data) => {
  try {
    console.log("Отправка данных менеджера:", data);

    const response = await axios.post("manager", data);

    if (response.status === 201 || response.status === 200) {
      setSuccessAdded(true);
      reset(); // сбрасываем форму только при успехе
    } else {
      setSuccessAdded(false);
      console.error("Неожиданный статус ответа:", response.status);
    }
  } catch (error) {
    setSuccessAdded(false);
    if (error.response?.data?.message) {
      console.error("Ошибка с сервера:", error.response.data.message);
    } else {
      console.error("Ошибка при добавлении менеджера:", error);
    }
  }
};

  return (
    <PagesWrapper>
      <styled.FormWrapper>
         <TopPageTitle value={'Додати менеджера'}/>
        {successAdded === null && <styled.Form onSubmit={handleSubmit(onSubmit)}>
            {fields.map(({ name, inputName }) => (
            <TextInput
               key={name}
               fieldName={inputName}
               name={name}
               register={register}
               errors={errors}
            />
            ))}
            <CommonBtn type="submit">Додати</CommonBtn>
         </styled.Form>}
         {successAdded === false && <p>Add manager was failed</p>}
         {successAdded === true && <p>Added manager successfully</p>}
      </styled.FormWrapper>
       
    </PagesWrapper>
  )
};

export default AddManager;
